import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthProvider';

interface RecoveryGuardProps {
  children: React.ReactNode;
}

export const RecoveryGuard: React.FC<RecoveryGuardProps> = ({ children }) => {
  const { isRecoverySession } = useAuth();
  const location = useLocation();

  // If this is a recovery session, only allow access to the reset password page
  if (isRecoverySession && location.pathname !== '/reset-password') {
    console.log('🔒 Recovery session detected - redirecting to reset password page');
    return <Navigate to="/reset-password" replace />;
  }

  return <>{children}</>;
};